import { AwaitResponse } from '@general/js/utils/MockUtils';

export default class RebateServicesMock {
  static retrieveRebateHistory() {
    const mockRes = {
      rebateEventHistory: [
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4324',
          },
          rebateEventType: 'R',
          rebateEventDate: '2022-10-09',
          status: 'REJECTED',
          batchId: '0303',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4324',
          },
          rebateEventType: 'R',
          rebateEventDate: '2022-10-09',
          status: 'REGISTRATION ACCEPTED',
          batchId: '0303',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'R',
          rebateEventDate: '2022-10-08',
          status: 'NEW',
          batchId: '0303',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'R',
          rebateEventDate: '2022-10-06',
          status: 'INITIAL',
          batchId: '0303',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '3423',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '6499',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '4354',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '4354',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '0999',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '8767',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '6326',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '7878',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '4942',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '4354',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '4534',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '5658',
        },
        {
          rebateApplicant: {
            firstName: 'SMTestAccount4',
            middleName: '',
            lastName: 'SMTestAccount4',
            personCode: '4384',
          },
          rebateEventType: 'C',
          rebateEventDate: '2022-10-06',
          status: 'NEW',
          batchId: '2065',
        },
      ],
      rebateTierHistory: [
        {
          rebateTier: 'TIER_1',
          startDate: '2022-06-01',
          endDate: '',
        },
        {
          rebateTier: 'TIER_3',
          startDate: '2022-05-30',
          endDate: '2022-03-04',
        },
        {
          rebateTier: 'TIER_1',
          startDate: '2022-02-01',
          endDate: '2022-03-04',
        },
        {
          rebateTier: 'TIER_1',
          startDate: '2022-01-01',
          endDate: '2022-02-01',
        },
        {
          rebateTier: 'TIER_2',
          startDate: '2021-10-30',
          endDate: '2021-12-24',
        },
        {
          rebateTier: 'BASE_TIER',
          startDate: '2021-09-05',
          endDate: '2021-10-07',
        },
        {
          rebateTier: 'NONE',
          startDate: '',
          endDate: '',
        },
        {
          rebateTier: 'TIER_1',
          startDate: '2021-02-01',
          endDate: '2021-02-27',
        },
        {
          rebateTier: 'BASE_TIER',
          startDate: '2021-01-25',
          endDate: '2021-01-30',
        },
        {
          rebateTier: 'BASE_TIER',
          startDate: '2020-10-09',
          endDate: '2021-01-25',
        },
        {
          rebateTier: 'TIER_3',
          startDate: '2020-08-12',
          endDate: '2020-09-09',
        },
        {
          rebateTier: 'TIER_2',
          startDate: '2020-05-10',
          endDate: '2020-08-12',
        },
      ],
      members: [
        {
          personCode: 'Member-1002x', // Remove x to mock Contributor person logged in scenario
          insurableType: 'C',
        },
      ],
    };

    return AwaitResponse(mockRes);
  }

  static getRebateLandingRefData() {
    const mockRes = {
      rebateOverviewDescriptionTextActive: {
        informationText:
          "The Australian Government rebate on private health insurance helps make it more affordable. It is based on income and the age of the oldest person covered by the policy. You can <a href='#' id='updateRebate'>update your rebate tier</a> any time. View the income thresholds or find out more from the&nbsp;<a href=\"https://www.ato.gov.au/\">ATO website</a>.",
      },
      managingYourRebateHeadingTextActive: {
        informationText: 'Manage your rebate',
      },
      managingYourRebateDescriptionTextActive: {
        informationText: "You can <a href='#' id='updateRebate'>change your rebate</a> tier at any time.",
      },
      managingYourRebateSubheading1TextActive: {
        informationText: 'Change rebate applicant',
      },
      managingYourRebateSubheading1ParagraphTextActive: {
        informationText:
          'Visit <a href="/portal/$memberNumber$/Member-Selection/Member-Details">member details</a> to check personal profile and access. To update member or rebate details, please <a href="/portal/$memberNumber$/Support/Contact-Us">contact us</a> and we&#39;ll be happy to help.',
      },
      managingYourRebateSubheading2TextActive: {
        informationText: 'Update Medicare details',
      },
      managingYourRebateSubheading2ParagraphTextActive: {
        informationText: 'Please call us on <a href="tel://1800335425">1800 335 425</a>&nbsp;to update Medicare details.',
      },
      managingYourRebateSubheading3TextActive: {
        informationText: 'Update member details',
      },
      managingYourRebateSubheading3ParagraphTextActive: {
        informationText:
          'Check your profile and access in the member details section of your portal.<br />\r\n<br />\r\nTo provide the rebate we collect personal information that is provided to Services Australia. You may choose to receive the rebate as a tax-offset. For more information, including how to access your information or make a complaint, see our <a href="/Other/Legal">Privacy Policy</a>.<br />\r\n&nbsp;',
      },
      rebateOverviewDescriptionTextInactive: {
        informationText:
          'The Australian Government rebate on private health insurance helps make it more affordable. It is based on income and the age of the oldest person covered by the policy. You can update your rebate tier any time. View the income thresholds or find out more from the&nbsp;<a href="https://www.ato.gov.au/">ATO website</a>.',
      },
      addARebateCallToActionSubtitleTextInactive: {
        informationText: 'Add the rebate to lower your premium',
      },
      // TODO: Below fields not used
      managingYourRebateHeadingTextInactive: {
        informationText: 'Manage your rebate',
      },
      managingYourRebateDescriptionTextInactive: {
        informationText: '',
      },
      managingYourRebateSubheading1TextInactive: {
        informationText: 'Change rebate applicant',
      },
      managingYourRebateSubheading1ParagraphTextInactive: {
        informationText: '',
      },
      managingYourRebateSubheading2TextInactive: {
        informationText: 'Update Medicare details',
      },
      managingYourRebateSubheading2ParagraphTextInactive: {
        informationText: '',
      },
      managingYourRebateSubheading3TextInactive: {
        informationText: 'Update member details',
      },
      managingYourRebateSubheading3ParagraphTextInactive: {
        informationText: '',
      },
    };

    return AwaitResponse(mockRes);
  }

  static getRebateTierHistoryRefData() {
    const mockRes = {
      rebateHistoryDescriptionTextActive: {
        informationText:
          'The rebate tier history shows previous levels of rebate on your Defence Health membership. If your income changes you can update your rebate tier at any time. Income thresholds are usually adjusted by the government annually.',
      },
      rebateHistoryDescriptionTextInactive: {
        informationText:
          'The rebate tier history shows previous levels of rebate on your Defence Health membership. Income thresholds are usually adjusted by the government annually.',
      },
      rebateHistoryInformationBannerTextInactive: {
        informationText: "<p>You currently do not have an active rebate. You can <a id='addRebate'>add a rebate</a> at any time.</p>",
      },
    };

    return AwaitResponse(mockRes);
  }

  static submitRebateRegistration() {
    return AwaitResponse({
      currentPremium: 0.0, // Decimal format
      newPremium: 199.78, // Decimal format
      currentPayFrequency: 'annual',
      rebateTier: 'string',
      operationType: 'string',
    });
  }

  static getAddRebateRefData() {
    return AwaitResponse({
      addARebateSubtext: {
        informationText:
          'The Australian Government rebate on private health insurance helps make it more affordable. For more information access the <a href="http://www.ato.gov.au/">ATO website</a> and view Rebate income tiers or visit <a href="/Support/Health-HQ">Health HQ</a>.​',
      },
      notCoveredAdultErrorText: {
        informationText: 'To add a rebate you need to be a covered adult.',
      },
      rebateApplicantCalloutText: {
        informationText:
          'In some cases, you may be able to add a rebate to this policy. Please have an eligible rebate applicant login to the Member Portal to complete the rebate application or alternatively call Defence Health.​',
      },
      medicareCardInformationText: {
        informationText: 'Please enter Medicare card information to claim rebate​',
      },
      incomeTierCalloutText: {
        informationText:
          'Even if it&rsquo;s only you on the policy, you need to consider all people in your household when nominating a rebate tier. Please see the ATO website for more information.​',
      },
      privacyStatementInformationText: {
        informationText:
          'The privacy and security of your personal information is important to us, and is protected by law. We need to collect this information so we can process and manage your applications and payments, and provide services to you. We only share your information with other parties where you have agreed, or where law allows or requires it. ​​<br />\r\n<br />\r\nFor more information, go to ​<a href="http://www.servicesaustralia.gov.au/privacy">servicesaustralia.gov.au/privacy</a>',
      },
      addARebateSuccessSubtext: {
        informationText:
          'This tier for the Australian Government Rebate on private health insurance, will be applied to the first premium payment received on or after your nominated effective date. You will receive a membership certificate reflecting this change.​',
      },
      premiumInformationInformationText: {
        informationText: '<strong>How your premium has changed</strong><br />\r\nYour premium has been updated based on your requested rebate tier.&nbsp;',
      },
      premiumAdjustmentInformationText: {
        informationText: 'Any changes to your premium will be automatically adjusted in your next bill. Alternatively, you can pay for the remaining amount due now.&nbsp;',
      },
      incomeTierSingleOptions: [
        {
          display: '$97,000 or less',
          returnValue: 'BASE_TIER',
        },
        {
          display: '$97,001 - $113,000',
          returnValue: 'TIER_1',
        },
        {
          display: '$113,001 - $151,000',
          returnValue: 'TIER_2',
        },
        {
          display: '$151,001 or more',
          returnValue: 'TIER_3',
        },
        {
          display: "Don't apply a rebate",
          returnValue: 'none',
        },
      ],
      incomeTierFamilyOptions: [
        {
          display: '$194,000 or less',
          returnValue: 'BASE_TIER',
        },
        {
          display: '$194,001 - $226,000',
          returnValue: 'TIER_1',
        },
        {
          display: '$226,001 - $302,000',
          returnValue: 'TIER_2',
        },
        {
          display: '$302,001 or more',
          returnValue: 'TIER_3',
        },
        {
          display: "Don't apply a rebate",
          returnValue: 'none',
        },
      ],
    });
  }

  static retrieveMembershipDetails() {
    return AwaitResponse({
      paymentStartDate: 'YYYY-MM-DD',
      coverStartDate: 'YYYY-MM-DD',
      datePaidTo: 'YYYY-MM-DD', // optional
      rebateApplicant: {
        firstName: 'FName', // Optional, return empty string if null
        middleName: 'MName', // Optional, return empty string if null
        lastName: 'Lname', // Optional, return empty string if null
        personCode: 'Member-100200000000',
      },
      rebate: {
        rebateTier: 'TIER_1',
        rebateCommencementDate: '2024-01-01', // YYYY-MM-DD
      },
    });
  }

  static getUpdateRebateRefData() {
    return AwaitResponse({
      rebateTierHeadingSubtitleText: {
        informationText:
          'You can update your rebate tier at any time. If you choose an incorrect rebate tier or your income fluctuates during the year, it will be reconciled by the Australian Taxation Office when you submit your tax return. For more information access the ATO website and view Rebate income tiers or visit Health HQ.',
      },
      rebateTierCurrentRebateRegistrationDateCalloutText: {
        informationText: 'This is the date that you submitted your current rebate registration request.',
      },
      rebateTierNewRebateTierEffectiveDateCalloutText: {
        informationText:
          'When you lodge your tax return, the ATO tests your income against the income thresholds to determine the level of rebate you are entitled to receive, based on the people in your household. If needed, your rebate amount will be reconciled by the ATO.',
      },
      rebateTierMyHouseholdIncomeCalloutText: {
        informationText:
          'Even if it’s only you on the policy, you need to consider all people in your household when nominating a rebate tier. Please see the ATO website for more information.',
      },
      rebateReviewAndSubmitMyPremiumCalloutText: {
        informationText: 'Your premium will change depending on the rebate tier you are adding to your policy.',
      },
      rebateReviewAndSubmitNoteText: {
        informationText: 'Please note, your rebate is applied to your base premium only.',
      },
      rebateSuccessHeadingSubtitleText: {
        informationText:
          'This tier for the Australian Government Rebate on private health insurance, will be applied to the first premium payment received on or after your nominated effective date. You will receive a membership certificate reflecting this change.',
      },
      rebateSuccessHowYourPremiumHasChangedSectionText: {
        informationText: '<h6>How your premium has changed</h6>Your premium has been updated based on your requested rebate tier.',
      },
      rebateSuccessYourPaymentAdjustmentSectionText: {
        informationText:
          'Your payment has been adjusted Any changes to your premium will be automatically adjusted in your next bill. Alternatively, you can pay for the remaining amount due now.',
      },
      incomeTierSingleOptions: [
        {
          display: '$97,000 or less',
          returnValue: 'BASE_TIER',
        },
        {
          display: '$97,001 - $113,000',
          returnValue: 'TIER_1',
        },
        {
          display: '$113,001 - $151,000',
          returnValue: 'TIER_2',
        },
        {
          display: '$151,001 or more',
          returnValue: 'TIER_3',
        },
        {
          display: "Don't apply a rebate",
          returnValue: 'none',
        },
      ],
      incomeTierFamilyOptions: [
        {
          display: '$194,000 or less',
          returnValue: 'BASE_TIER',
        },
        {
          display: '$194,001 - $226,000',
          returnValue: 'TIER_1',
        },
        {
          display: '$226,001 - $302,000',
          returnValue: 'TIER_2',
        },
        {
          display: '$302,001 or more',
          returnValue: 'TIER_3',
        },
        {
          display: "Don't apply a rebate",
          returnValue: 'none',
        },
      ],
    });
  }

  static submitUpdatedRebateTier() {
    return AwaitResponse({
      currentPremium: 0.0, // Decimal format
      newPremium: 180.78, // Decimal format
      currentPayFrequency: 'annual',
      rebateTier: 'string',
      operationType: 'string',
    });
  }

  static submitRebateWithdrawal() {
    return AwaitResponse({
      currentPremium: 0.0, // Decimal format
      newPremium: 150.78, // Decimal format
      currentPayFrequency: 'annual',
      rebateTier: 'string',
      operationType: 'string',
    });
  }

  static getWithdrawRebateRefData() {
    return AwaitResponse({
      withdrawRebateHeadingSubtitleText: {
        informationText:
          'You can withdraw your rebate tier at any time. Learn more about the rebate and other government initiatives at the ATO Website, or see more information at Health HQ.',
      },
      withdrawRebateReviewAndSubmitMyPremiumCalloutText: {
        informationText: 'Your premium will change after the rebate is withdrawn',
      },
      withdrawRebateReviewAndSubmitNoteText: {
        informationText: 'Please note, your rebate effects your base premium only.',
      },
      withdrawRebateSuccessHeadingSubtitleText: {
        informationText:
          'This tier for the Australian Government Rebate on private health insurance, will be applied to the first premium payment received on or after your nominated effective date. You will receive a membership certificate reflecting this change.',
      },
    });
  }

  static estimateNewPremium() {
    return AwaitResponse({
      currentPremium: 456.0,
      newPremium: 123.45,
    });
  }
}
